import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'whatwg-fetch';
class getCambiarEstado extends Component {
  constructor(){
    super();
    this.state = {
        forma_pago :"",
        razon_social :"CONSUMIDOR FINAL",
        ruc:"9999999999999",
        telefono:"S/N",
        direccion:"S/N",
        email:"S/N",
        alias:"",
        total_precio:0,
        costo_delivery:0,
        total_final:0,
        lista_items:[],
        fecha_creacion:'',
        cod_pedido:'',
        lon:0,
        lat:0,
        minutos:0,
        id_sucursal_transferencia:0,
        data_sucursal_transferencia:[],
        id_sucursal:0,
        lista_minutos :[
          {"tiempo":10,"label":"10 Minutos"},
          {"tiempo":5,"label":"5 Minutos"},
          {"tiempo":15,"label":"15 Minutos"},
          {"tiempo":20,"label":"20 Minutos"},
          {"tiempo":30,"label":"30 Minutos"},
          {"tiempo":40,"label":"40 Minutos"},
          {"tiempo":50,"label":"50 Minutos"}
        ],
        id_forma_pago : 0,
        data:'',
        number:'',
        uuid_cliente:'',
        id_forma_pedido:0,
        valor_efectivo:0,
        lista_motorizados:[],
        id_motorizado:0
    }
  }
  get_SucursalTransferencia =()=>{
    const url= this.props.dir_url + "webapp/getSucursalTransferencia";
    const token =  this.props.token
    const token_Pedido =  this.props.token_pedido
    const id_sucursal = this.state.id_sucursal
    var obj = { accion:'sucursaltransferencia', token, token_Pedido,id_sucursal};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data)
      if(data[0].status==="ok"){
        this.setState({
          data_sucursal_transferencia:[data[0].msg[0]]
        },()=>{
          this.get_Motorizados(id_sucursal)
        })
      }else{
        this.setState({
          data_sucursal_transferencia:[]
        },()=>{
          this.get_Motorizados(id_sucursal)
        })
      }
    })
    .catch(console.log)
  }
  get_Pedido =()=>{
    const url= this.props.dir_url + "webapp/getDatosDetallePedido";
    const token =  this.props.token
    const token_Pedido =  this.props.token_pedido
    var obj = { accion:'datosdetallepedido', token, token_Pedido};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data)
      if(data[0].status==="ok"){
        this.setState({
          uuid_cliente:data[0].msg[0].uuid_cliente,
          lon:data[0].msg[0].lon,
          lat:data[0].msg[0].lat,
          forma_pago:data[0].msg[0].forma_pago,
          razon_social:data[0].msg[0].razon_social,
          ruc:data[0].msg[0].ruc,
          telefono:data[0].msg[0].telefono,
          direccion:data[0].msg[0].direccion,
          email:data[0].msg[0].correo_electronico,
          alias:data[0].msg[0].alias,
          total_final:data[0].msg[0].total,
          costo_delivery:data[0].msg[0].delivery,
          fecha_creacion:data[0].msg[0].fecha_creacion,
          cod_pedido:data[0].msg[0].cod_pedido,
          lista_items:data[0].msg,
          id_estado_pedido:data[0].msg[0].id_estado_pedido,
          id_forma_pago :data[0].msg[0].id_forma_pago,
          data:data[0].msg[0].data,
          number:data[0].msg[0].number,
          id_forma_pedido:data[0].msg[0].id_forma_pedido,
          valor_efectivo:data[0].msg[0].valor_efectivo,
          id_sucursal:Number(data[0].msg[0].id_sucursal),
          id_motorizado:data[0].msg[0].id_motorizado
        },()=>{
          this.get_SucursalTransferencia()
        })
      }
    })
    .catch(console.log)
  }

  get_Motorizados =(id_sucursal)=>{
    const url= this.props.dir_url + "webapp/getDatosMotorizados";
    const token =  this.props.token
    const token_Pedido =  this.props.token_pedido
    var obj = { accion:'datosmotorizados', token, token_Pedido,id_sucursal};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data)
      if(data[0].status==="ok"){
        this.setState({
            lista_motorizados:data[0].msg
        })
      }
    })
    .catch(console.log)
  }

  getData = () =>{
    let data = this.state.data
    if(data!==''){
      var CryptoJS = require("crypto-js");
      var bytes  = CryptoJS.AES.decrypt(data.toString(), "_RESP_"+this.state.uuid_cliente+"_RESP_"+this.state.number);
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var res = plaintext.split("(,)");
      if(res.length===4){
        return(
          <React.Fragment>
          <div className="grid-container_buy_getpedido">
            <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  /></div>
            <div className="lbl_icon_final_buy_getpedido"><span>{this.state.razon_social} - {this.state.ruc}</span></div>
          </div>
            <div className="grid-container_buy_getpedido cssversion_img">
              <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  /></div>
              <div className="lbl_icon_final_buy_getpedido"><span>{res[0]} - {res[1]} - {res[2]}</span></div>
            </div>
            <div className="grid-container_buy_getpedido cssversion_img">
              <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  /></div>
              <div className="lbl_icon_final_buy_getpedido"><span>{res[3]}</span></div>
            </div>
          </React.Fragment>
        )
      }
    }
  }
  rechazar_pedido=()=>{
     confirmAlert({
       title: 'Rechazar Pedido',
       message: '¿Desea Rechazar Pedido?',
       buttons: [
         {
           label: 'Sí',
           onClick: () => this.get_cambiar_estado('rechazar')
         },
         {
           label: 'No',
           onClick: () => this.get_opcion_no()
         }
       ]
     })
   }
   get_finalizar_transferencia =()=>{
     const id_sucursal_transferencia= this.state.id_sucursal_transferencia
     if(Number(id_sucursal_transferencia)<=0){
       return null
     }
     const url= this.props.dir_url + "webapp/getTransferirPedido";
     const token =  this.props.token
     const token_Pedido =  this.props.token_pedido
     var obj = { accion:'transferirpedido', token, token_Pedido,id_sucursal_transferencia};
     fetch(url, {
       method: 'POST',
       body: JSON.stringify(obj),
       headers:{
         'Accept':'application/json',
         'Content-Type': 'application/json'
       }
     })
     .then(res => res.json())
     .then((data) => {
       //console.log(data)
       this.regresar()
     })
     .catch(console.log)
   }
   transferir_pedido=()=>{
      confirmAlert({
        title: 'Transferir Pedido',
        message: '¿Desea Transferir Pedido?',
        buttons: [
          {
            label: 'Sí',
            onClick: () => this.get_finalizar_transferencia()
          },
          {
            label: 'No',
            onClick: () => this.get_opcion_no()
          }
        ]
      })
    }
   get_transferir=()=>{
     if(Number(this.state.id_sucursal_transferencia)>0){
       this.transferir_pedido();
     }
   }
   get_cambiar_estado =(opcion)=>{
     let id_motorizado = -1
     const id_tipo_permiso =  Number(this.props.id_tipo_permiso)
     let tiempo_estimado =0
     let id_estado_pedido = 0
      if(opcion==='rechazar'){
        id_estado_pedido = 4
      }
      if(opcion==='preparar'){
        if(id_tipo_permiso!==3){
          const minutos = this.state.minutos
          if(Number(minutos)===0){
            alert("Ingrese Tiempo de Preparación + Entrega")
            return
          }
          tiempo_estimado = minutos
        }else{
          tiempo_estimado = 30
        }
        id_estado_pedido = 1
      }
      if(opcion==='enviando'){
        const minutos = this.state.minutos
        id_motorizado = this.state.id_motorizado
        if(Number(minutos)===0){
          alert("Ingrese Tiempo de Entrega")
          return
        }
        tiempo_estimado = minutos
        id_estado_pedido = 2
      }
      if(opcion==='finalizado'){
        id_estado_pedido = 7
      }
      if(Number(id_estado_pedido)>0){
        const url= this.props.dir_url + "webapp/getUpdatePedido";
        const token =  this.props.token
        const token_Pedido =  this.props.token_pedido
        var obj = { accion:'updatepedido', token, token_Pedido,id_estado_pedido,tiempo_estimado,id_tipo_permiso,id_motorizado};
        fetch(url, {
          method: 'POST',
          body: JSON.stringify(obj),
          headers:{
            'Accept':'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(res => res.json())
        .then((data) => {
          console.log(data)
          this.regresar()
        })
        .catch(console.log)
      }
   }
   get_opcion_no =()=>{

   }
   regresar =()=>{
     this.props.get_salir_vista_pedido()
   }
   handleChanget = (event)=>{
     this.setState({
        minutos: event.target.value
     });
   }
   handleChangeM = (event)=>{
     this.setState({
        id_motorizado: event.target.value
     });
   }
   handleChangetT = (event)=>{
     this.setState({
        id_sucursal_transferencia: event.target.value
     });
   }
   get_Detalle_Pedido =()=>{
     //{this.mostrarItems()}
     const id_tipo_permiso =  Number(this.props.id_tipo_permiso)
     const id_estado_pedido = this.state.id_estado_pedido
     const lista_minutos =this.state.lista_minutos
     const data_sucursal_transferencia = this.state.data_sucursal_transferencia
     const lista_motorizados = this.state.lista_motorizados
     //console.log(this.state.id_motorizado)
     return (
       <React.Fragment>
         <div className="grid-container_getpedido" style={{"backgroundColor":"#04c46c","color":"white"}} >
           <div className="lbl_title_final_getpedido" > DATOS DEL PEDIDO</div>
           <div className="lbl_icon_final_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  /></div>
         </div>
         <div className="grid-container_buy_getpedido">
           <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4609047631582004492-128.png') }  /></div>
           <div className="lbl_icon_final_buy_getpedido">Fecha del Pedido: {this.state.fecha_creacion}</div>
         </div>
         <div className="grid-container_buy_getpedido">
           <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4609047631582004492-128.png') }  /></div>
           <div className="lbl_icon_final_buy_getpedido">Código de Pedido: {this.state.cod_pedido}</div>
         </div>
         <div className="grid-container-menu_list-datos_pedidos_totales">
           <div className="div_menu_1_list-datos_pedidos_totales">Subtotal Productos</div>
           <div className="lbl_menu_2_list-datos_pedidos_totales">${(Number(this.state.total_final)-Number(this.state.costo_delivery)).toFixed(2)}</div>
         </div>
         <div className="grid-container-menu_list-datos_pedidos_totales">
           <div className="div_menu_1_list-datos_pedidos_totales">Transporte</div>
           <div className="lbl_menu_2_list-datos_pedidos_totales">${Number(this.state.costo_delivery).toFixed(2)}</div>
         </div>
         <div className="grid-container-menu_list-datos_pedidos_totales">
           <div className="div_menu_1_list-datos_pedidos_totales">Total Comprobante</div>
           <div className="lbl_menu_2_list-datos_pedidos_totales">${Number(this.state.total_final).toFixed(2)}</div>
         </div>
         <div>
         {(Number(id_estado_pedido)===6)?
         <React.Fragment>
           <div className="grid-container_buy_getpedido">
             <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  /></div>
             <div className="lbl_icon_final_buy_getpedido">FORMA DE PAGO {this.state.forma_pago}
               <div className="cssversion_pxh50 cssversion_pxw70 cssversion_contentCenter" style={{"display":"flex"}}>
                 <div className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#82E0AA","borderRadius": "15px"}}>
                   <span className="span-global" style={{"color":"white"}}>{this.state.valor_efectivo}$</span>
                 </div>
               </div>
             </div>
           </div>
           {(Number(this.state.id_forma_pago)>0&&id_tipo_permiso!==3)?
             this.getData()
             :''
           }
          {(Number(this.state.id_forma_pedido)===0||Number(this.state.id_forma_pedido)===1
            ||Number(this.state.id_forma_pedido)===2||Number(this.state.id_forma_pedido)===4
          ||Number(this.state.id_forma_pedido)===5)?
            <React.Fragment>
             <button style={{"width":"250px"}} className="button-global" onClick={ () => this.get_cambiar_estado('preparar')}>
             ACEPTAR PEDIDO
             </button>
             <br/>
             <React.Fragment>
             {(id_tipo_permiso!==3)?
               <select className="select-css_global" value={this.state.minutos} onChange={(e) => {this.handleChanget(e)}}>
                   <option value="0">Seleccione Tiempo de Preparación</option>
                   {(lista_minutos.length !== 0) ?
                     lista_minutos.map(minuto => (
                       <option key={minuto.tiempo} value={minuto.tiempo} >{minuto.label}</option>
                     ))
                     : <React.Fragment></React.Fragment>
                   }
                 </select>
             :''
            }
            <br/>
            <span className="span-global">Locales disponibles para Transferir:</span>
            <br/>

            <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
              <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                <select className="select-css_global" value={this.state.id_sucursal_transferencia} onChange={(e) => {this.handleChangetT(e)}}>
                  <option value="0">Seleccione Sucursal para Transferir Pedido</option>
                  {(data_sucursal_transferencia.length !== 0) ?
                    data_sucursal_transferencia.map(suc_tra => (
                      <option key={suc_tra.id_sucursales} value={suc_tra.id_sucursales} >{suc_tra.sucursales}</option>
                    ))
                    : <React.Fragment></React.Fragment>
                  }
                </select>
              </div>
              <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                <button style={{"width":"250px","padding":"10px"}} className="button-global" onClick={ () => this.get_transferir()}>
                TRANSFERIR
                </button>
              </div>
            </div>


            </React.Fragment>
           </React.Fragment>
           :''}
           {(Number(this.state.id_forma_pedido)===3)?
             <button style={{"width":"250px"}} className="button-global" onClick={ () => this.get_cambiar_estado('finalizado')}>
             ACEPTAR PEDIDO
             </button>
           :''}
           <br/>
           <button style={{"width":"250px"}} className="button-global" onClick={ () => this.rechazar_pedido()}>
           RECHAZAR PEDIDO
           </button>
          </React.Fragment>
         :''}
         {(Number(id_estado_pedido)===1)?
         <React.Fragment>
           {(Number(this.state.id_forma_pedido)===0)?
           <button style={{"width":"250px"}} className="button-global" onClick={ () => this.get_cambiar_estado('enviando')}>
           EMPEZAR ENTREGA
           </button>
           :
           <button style={{"width":"250px"}} className="button-global" onClick={ () => this.get_cambiar_estado('finalizado')}>
           FINALIZAR
           </button>
           }
           <br/>
           <select className="select-css_global" value={this.state.minutos} onChange={(e) => {this.handleChanget(e)}}>
           <option value="0">Seleccione Tiempo de Entrega</option>
           {(lista_minutos.length !== 0) ?
             lista_minutos.map(minuto => (
               <option key={minuto.tiempo} value={minuto.tiempo} >{minuto.label}</option>
             ))
             : <React.Fragment></React.Fragment>
           }
         </select>
           <br/>
           <select className="select-css_global" value={this.state.id_motorizado} onChange={(e) => {this.handleChangeM(e)}}>
               <option value="0">Seleccione Motorizado</option>
               {(lista_motorizados.length !== 0) ?
                 lista_motorizados.map(motorizado => (
                   <option key={motorizado.id_motorizado} value={motorizado.id_motorizado} >{motorizado.usuario}</option>
                 ))
                 : <React.Fragment></React.Fragment>
               }
             </select>
            <br/>
            {(id_tipo_permiso!==3)?
            <button style={{"width":"250px"}} className="button-global" onClick={ () => this.rechazar_pedido()}>
            CANCELAR PEDIDO
            </button>:null}
           </React.Fragment>
          :''}
         {(Number(id_estado_pedido)===2)?
         <React.Fragment>
           <button style={{"width":"250px"}} className="button-global" onClick={ () => this.get_cambiar_estado('finalizado')}>
           PEDIDO ENTREGADO A CLIENTE
           </button>
           <br/>
           {(id_tipo_permiso!==3)?
           <button style={{"width":"250px"}} className="button-global" onClick={ () => this.rechazar_pedido()}>
           CANCELAR PEDIDO
           </button>:null}
          </React.Fragment>
         :''}
         </div>
       </React.Fragment>
     )
   }
   render () {
     return (
       <React.Fragment>
       <div className="div_global_registre_U_datasucursal">
         <div className="grid-container_">
           <div className="lbl_imagen_" onClick={ () => this.regresar()}><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } /></div>
           <div className="lbl_text_" style={{"color":"black"}}>Cambiar Estado</div>
         </div>
         <div style={{"height": "90%","overflowY": "auto"}}>
           <div>
           {this.get_Detalle_Pedido()}
           </div>
         </div>
       </div>
       </React.Fragment>
     )
   }
   componentDidMount (){

     this.get_Pedido()

   }

}
export default getCambiarEstado;
